module.exports = __webpack_public_path__ + "img/download.325ac0c9.svg";